<div class="wrap" appChangeColorTheme attribute="bgc">

  <div class="logo">
    <fa-icon [icon]="getFaIcon('faHome')" (click)="goHome()"></fa-icon>
    <fa-icon class="icon_admin" *ngIf="isAdmin()" [icon]="getFaIcon('faTh')" [routerLink]="'/admin'"
      [matTooltip]="'Menu'"></fa-icon>
    <!-- <fa-icon class="icon_admin" *ngIf="isAdmin() && userConnect?.role !== 'planning'"
      [icon]="getFaIcon('faCashRegister')" (click)="goToMenu('counter')"
      [matTooltip]="userConnect?.role === 'admin' ? 'Choisir un guichet' : 'Mon guichet'"></fa-icon>
    <fa-icon class="icon_admin" *ngIf="isAdmin() && userConnect?.role !== 'counter' "
      [icon]="getFaIcon('faCalendarAlt')" (click)="goToMenu('planing')"
      [matTooltip]="userConnect?.role === 'admin' ? 'Choisir un planing' : 'Mon planing'"></fa-icon>
    <span *ngIf="userConnect?.role === 'club'">Club : {{userConnect?.club_code}}</span> -->
  </div>

  <div class="title">
    <h1>Bienvenue {{user?.firstName}} {{user?.lastName}}</h1>
  </div>

  <div class="btn_action">
    <div class="sign_in" *ngIf="!userConnect && router.url !=='/espace-pro' " (click)="openDialogLogin()">
      <fa-icon [icon]="getFaIcon('faSingInAlt')"></fa-icon>
      Connexion
    </div>
    <div class="isConnect" *ngIf="userConnect">

      <div class="search" *ngIf="showIcons" (click)="goHome(true)">
        <fa-icon [icon]="getFaIcon('faSearch')"></fa-icon>
      </div>

      <!-- <div class="basket" [routerLink]="['/home/my-shopping-bag']" routerLinkActive="router-link-active"
        *ngIf="showIcons">
        <fa-icon class="shop" [icon]="getFaIcon('faShoppingBasket')"></fa-icon>
        <span *ngIf="myShoppingBagLength > 0">{{myShoppingBagLength}}</span>
      </div> -->

      <fa-icon class="user" [icon]="getFaIcon('faUser')" (click)="showPopUpSignIn()"></fa-icon>
    </div>
    <app-pop-up-shopping-basket *ngIf="popUpShop" [@popUpAnim]></app-pop-up-shopping-basket>
    <app-pop-up-sign-in *ngIf="popUpSignIn" [@popUpAnim] [user]="user"></app-pop-up-sign-in>
  </div>
</div>
